import React from 'react';
import { Box, Text } from '@wix/design-system';
import { SwitchContent } from './SwitchContent';
import { Countdown } from 'components/Countdown';
import { Trans, useTranslation } from 'react-i18next';
import s from './Content.scss';
import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from 'providers';

const LastSaleDayComponent = ({ rootStore }: { rootStore: RootStore }) => {
  const { t } = useTranslation();
  const {
    appContext: { saleParams },
  } = rootStore.appStore;

  return (
    <SwitchContent
      texts={[
        t('premium-purchase-plan.header.strip.money_back'),

        <Box
          direction='horizontal'
          verticalAlign='middle'
          gap='18px'
          padding='6px 0'
        >
          <Text light weight='bold'>
            <Trans
              i18nKey='sale.banner.last_day_countdown'
              values={{ percent: 50 }}
            />
          </Text>
          <Box verticalAlign='middle'>
            <Countdown
              currentDate={saleParams.currentDateUtc}
              endDate={saleParams.saleEndDate}
              classNames={{
                wrapper: s.countdown,
                timePart: s.countdownTimePart,
                label: s.countdownTimePartLabel,
                separator: s.countdownSeparator,
                timePartWrapper: s.countdownTimePartWrapper,
              }}
              timePartProps={{ light: true, weight: 'bold' }}
              separatorProps={{ light: true, weight: 'bold' }}
              timePartLabelProps={{ light: true }}
            />
          </Box>
        </Box>,
      ]}
    />
  );
};

export const LastSaleDay = withInjectedRootStore(
  observer(LastSaleDayComponent),
);
